/**
 * @description 导出网络配置
 */
export const baseURL = process.env.NODE_ENV === 'development' ? '/api' : '/api';
/** 配后端数据的接收方式application/json;charset=UTF-8 或 application/x-www-form-urlencoded;charset=UTF-8 */
export const contentType = 'application/json;charset=UTF-8';
/** 最长请求时间 */
export const requestTimeout = 1000 * 60 * 30;
/** 传输加密开关 */
export const secrecy = false; // process.env.NODE_ENV !== "development"
/** 加载动画显示文字 */
export const loadingText = '请稍候...';
/** 防重复提交 */
export const debounce = [
  'edit',
  'add',
  'update',
  'delete',
  'del',
  'download',
  'down',
  'insert',
  'export',
];
/** token名称 */
export const tokenName = 'token';
/** 路由白名单，如果需要放行带传参的页面，请使用query传参 */
export const routesWhiteList = [
  '/login',
  '/login-auth',
  '/callback',
  '/404',
  '/403',
];
export default {
  baseURL,
  contentType,
  requestTimeout,
  secrecy,
  loadingText,
  debounce,
  tokenName,
  routesWhiteList,
};
